"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const common_utils_1 = require("@as-react/common-utils");
const GoogleTagManager = (options = {}) => events => {
    const dataLayerName = (options.dataLayerName || 'dataLayer');
    if (typeof window === 'undefined') {
        return;
    }
    if (!window[dataLayerName] || typeof window[dataLayerName].push !== 'function') {
        console.warn(`redux-beacon error: window.${dataLayerName} is not defined. Have you forgotten to include Google Tag Manager and dataLayer?`);
        return;
    }
    events.forEach(event => {
        if (!(0, common_utils_1.isNullOrUndefined)(event)) {
            const eventToPush = (() => {
                if (event.event === undefined && event.hitType !== undefined) {
                    return Object.assign({}, event, { event: event.hitType });
                }
                return event;
            })();
            window[dataLayerName].push(eventToPush);
        }
    });
};
exports.default = GoogleTagManager;
//# sourceMappingURL=google-tag-manager.js.map